import type { FC } from 'react'
import styled from '@emotion/styled'
import { m } from 'framer-motion'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import BreakdownSilosBetweenTeamsImage from './BreakdownSilosBetweenTeamsImage'

const copy = {
  heading: `Break down the silos between teams`,
  description: `Unblock the business teams that support growth, implement the best tools in days, not months, and power your decisions with the same data.`,
}

const BreakdownSilosBetweenTeams: FC = () => {
  return (
    <SectionBase variant="2Col">
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ImageWrapper
          initial={{ opacity: 0 }}
          whileInView={{
            opacity: 1,
            transition: {
              duration: 0.4,
              delay: 0.1,
            },
          }}
          viewport={{ once: true }}
        >
          <BreakdownSilosBetweenTeamsImage />
        </ImageWrapper>
      </Section.Contents>
    </SectionBase>
  )
}

export default BreakdownSilosBetweenTeams

const ImageWrapper = styled(m.div)``
